export const iconFontAwesomeGamingDiceOne = (
	<i className="fa-solid fa-dice-one"></i>
);
